import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import packageJson from '../../package.json';  // package.json'ı import et

const Footer = () => {
    const version = packageJson.version;  // version bilgisini package.json'dan al
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            {new Date().getFullYear()} © RSK.
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-sm-block">
                                Design & Develop by rooter | Version: {version}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;